import { PopupModal } from 'react-calendly';
import { useCalendlyEventListener } from "react-calendly";
import axios from 'axios'
import { getLocalUser } from '../../../../components/functions/utilities';
// import { PrefilledCalendly } from '../header/header';
export interface ScheduleDemoAnswers {
    customerType: string;
    name: string;
    emailId: string;
    phoneNumber: string;
    companyWebsite: string;
    referredFrom: string;
    clickedClose?: string;
}

export interface PrefilledCalendly {
    name: string;
    email: string;
}

type Props = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;
    prefillValues: PrefilledCalendly
}

const CalendlyPopup = ({ showPopup, setShowPopup, prefillValues }: Props) => {
    useCalendlyEventListener({
        onEventScheduled: (e) => {
            console.log(e.data.payload);
            onSubmit();
        },
    });
    const user = getLocalUser();

    const onSubmit = async () => {
        // console.log(values);
        let submittedValues: ScheduleDemoAnswers = {
            customerType: "Brand",
            name: user.name,
            emailId: user.email,
            phoneNumber: user.phoneNumber,
            companyWebsite: "",
            referredFrom: "Merito App | Goals Hub",
        };
        // setLoading(true);
        try {
            const data = await axios
                .post(
                    `${import.meta.env.VITE_IP_DEV_REST_LOCATION}/api/clickmerito/leads`,
                    submittedValues
                )
                .then((res) => res.data);

        } catch (error) {

            console.log(error);
        }
    };

    let utm = {
        utmCampaign: 'Merito',
        utmContent: '',
        utmMedium: '',
        utmSource: 'App',
        utmTerm: ''
    }
    return (<PopupModal
        url="https://calendly.com/abhishek-click-merito/30min?hide_gdpr_banner=1"
        // url='https://calendly.com/mithun-merito/30min?hide_gdpr_banner=1'
        utm={utm}
        onModalClose={() => setShowPopup(false)}
        open={showPopup}

        rootElement={document.getElementById("root")}
        pageSettings={{
            backgroundColor: 'f0eff4',
            hideEventTypeDetails: false,
            hideLandingPageDetails: false,
            primaryColor: '100828',
            textColor: '100828'
        }}
        prefill={{ name: prefillValues.name, email: prefillValues.email }}
    />)
}


export default CalendlyPopup;